module.exports = __webpack_public_path__ + "img/pro_four_7.3128a654.jpg";